import axios from 'axios';
import swal from 'sweetalert2';
// Add a response interceptor
axios.interceptors.response.use((response) => response, function (error) {
    // Do something with response error
    if(!error.response){
        swal("Server error", "Please refresh and try later...", "error");
    }else if(error.response.status ===  401){
        sessionStorage.removeItem("auth-token");
        //swal("Token expired.","Refresh the page", "error");
        swal({ 
             title: "Token expired.",
             text: "Refresh the page",
             type: "error" 
        })
    }
    return Promise.reject(error.response);
  });
  



// WEBPACK FOOTER //
// ./src/config/httpConfig.js